import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/11.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Rzemieślnicy"
            question=""
            audio={audio}
            answers={{
                ans1: "Wchodzę do szewca, zgodnie z planem.",
                ans2: "Idę do warsztatu z płytkami.",
            }}
            links={{
                link1: PAGES.p26,
                link2: PAGES.p27,
            }}
            content={
                <div>
                    <p>
                        Noc mija spokojnie. Dzięki nadwarciańskiemu powietrzu śpisz jak dziecko. O świcie Emil wyjeżdża do Zagórowa zawieźć śliwki do Garfunkelów.
                    </p>
                    <ul>
                        <li>
                            Muszą zdążyć naszykować wszystko na wieczór – mamrocze zaspany, jakby przekonywał sam siebie do wyjścia z domu. Szybko postanawiasz, że pojedziesz z nim, żeby z samego rana iść do szewca, zgodnie ze wskazówkami kantora. Opowiadał, że jest nawet kilku szewców – zelówkarz robi zelówki, cholewkarz cholewki, a szteper górną część buta, do której przymocowuje się podeszwę. Zgarniasz szybko pajdę chleba z gęsim smalcem ze stołu i wskakujesz na wóz.
                        </li>
                    </ul>
                    <p>
                        Kiedy docierasz na miejsce, zauważasz, że naprzeciwko warsztatu szewca jest inny zakład, a przy nim leżą ceramiczne płytki niezwykłej urody. Ich połyskliwe szkliwo odbija promienie słońca, a Ty zastanawiasz się, czy na pewno chcesz robić buty, czy jednak poszukać szczęścia w warsztacie naprzeciwko…
                    </p>
                </div>
            }
        />

    );
}